export default "__VITE_ASSET__zCayWO$5__"